import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { UpdateOrderPayload } from "shared/api/middleware-api-client";

// Function to create a standard order payment link
const handleZakelijkBankTransferFunction = async (
  orderId: string,
  payload: UpdateOrderPayload,
) => {
  const res = await api().gersUpdateDoorOrder(orderId, payload);

  return res.data;
};

// Custom hook to handle the creation of a payment link for a standard product
export const useHandleZakelijkBankTransfer = () => {
  const {
    mutate: handleZakelijkBankTransfer,
    isLoading: isBankTransferLoading,
  } = useMutation(
    ({ orderId, payload }: { orderId: string; payload: UpdateOrderPayload }) =>
      handleZakelijkBankTransferFunction(orderId, payload),
    {
      // Redirect to the payment URL on successful creation of the payment link
      onSuccess: async (data, variables) => {
        window.location.href = `../afspraak-status/?orderId=${variables.orderId}`;
      },
      // Show an error toast if there is an error during the creation of the payment link
      onError: () => {
        toast.error("Er is iets fout gegaan in het betaalproces.");
      },
    },
  );

  // Return the mutation function and loading state
  return {
    handleZakelijkBankTransfer,
    isBankTransferLoading,
  };
};
